const userID = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).Account
  : ''

const realName = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).UserName
  : ''

const SourceNo = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).SourceNo
  : ''

const openInterview = localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo')).openInterview
    : ''

const DeptName = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).DeptName
  : ''

const TeachName = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).TeachName
  : ''

const TrainName = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).TrainName
  : ''

const haveInterview = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).haveInterview
  : ''

const identity = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).Identity
  : ''

const roletype = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).RoleType
  : ''

const birthday = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).Birthday
  : ''

const headPhoto = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo')).HeadPhoto
  : ''
const ApiUrl = ''

var selectMenuList = localStorage.getItem('MenuList')
  ? JSON.parse(localStorage.getItem('MenuList'))
  : []
var selectMenu = localStorage.getItem('SelectMenu')
  ? JSON.parse(localStorage.getItem('SelectMenu'))
  : {}

var companyLogo = sessionStorage.getItem('systemInfo')
  ? JSON.parse(sessionStorage.getItem('systemInfo')).CompanyLogo
  : ''
const companyNM = sessionStorage.getItem('systemInfo')
  ? JSON.parse(sessionStorage.getItem('systemInfo')).CompanyNM
  : ''

const systemNM = sessionStorage.getItem('systemInfo')
  ? JSON.parse(sessionStorage.getItem('systemInfo')).SystemNM
  : ''

const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57]|16[0-9])[0-9]{8}$/

import Vue from 'vue'
import ElementUI from 'element-ui'
import CryptoJS from "crypto-js";
// const keyStr = '890EECEE73FEB38A21AB258E4CF992CC';//国科大新的key
// const keyStr = 'C16D81FD0816578F623370F1C870DE03';//老的key

// keyStr 修改为根据动态配置取值
const keyStr =process.env.VUE_APP_KEY;
Vue.use(ElementUI)
function setSelectMenu(obj) {
  let isExist = false
  for (let i = 0; i < selectMenuList.length; i++) {
    if (selectMenuList[i].hash === obj.hash) {
      isExist = true
      break
    }
  }
  if (!isExist) {
    selectMenuList.push(obj)
  }
  localStorage.setItem('MenuList', JSON.stringify(selectMenuList))
  localStorage.setItem('SelectMenu', JSON.stringify(obj))
}
function SetMenuList(MList) {
  selectMenuList = MList
  localStorage.setItem('MenuList', JSON.stringify(selectMenuList))
}
//校验手机格式
function checkMobile(mobile) {
  return RegExp(/^1[345789]\d{9}$/).test(mobile)
}
function getCurrentTime() {
  //获取当前时间并打印
  var _this = this
  let yy = new Date().getFullYear()
  let mm = new Date().getMonth() + 1
  let dd = new Date().getDate()
  let hh = new Date().getHours()
  let mf =
    new Date().getMinutes() < 10
      ? '0' + new Date().getMinutes()
      : new Date().getMinutes()
  let ss =
    new Date().getSeconds() < 10
      ? '0' + new Date().getSeconds()
      : new Date().getSeconds()
  _this.gettime = yy + '/' + mm + '/' + dd + ' ' + hh + ':' + mf + ':' + ss
  return _this.gettime
}

function formatDate(dateObj, formatStr) {
  // 将日期对象转换为指定格式的字符串
  // formatStr：字符串格式，例如 "YYYY-MM-DD HH:mm:ss"
  var year = dateObj.getFullYear();
  var month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  var day = ("0" + dateObj.getDate()).slice(-2);
  var hour = ("0" + dateObj.getHours()).slice(-2);
  var minute = ("0" + dateObj.getMinutes()).slice(-2);
  var second = ("0" + dateObj.getSeconds()).slice(-2);
  return formatStr
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hour)
    .replace('mm', minute)
    .replace('ss', second);
}

function formatgetDate(dateObj,formatStr) {
  // 将日期对象转换为指定格式的字符串
  // formatStr：字符串格式，例如 "YYYY-MM-DD HH:mm:ss"
  var year = dateObj.getFullYear();
  var month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  var day = ("0" + dateObj.getDate()).slice(-2);
  return formatStr
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
}

//根据选项查询 
function querycensus(data){
  let Now = new Date();
  let oldDate = '';
  let getMonth = Now.getMonth() + 1; // 当前月份（1-12）
  let year = Now.getFullYear();
  
  // 计算推前的月份
  let targetMonth = getMonth - data;
  if (targetMonth <= 0) {
    year -= targetMonth==0?1:Math.ceil(Math.abs(targetMonth) / 12); // 如果月份小于等于0，减少年份
    targetMonth = 12 + (targetMonth % 12); // 计算新的月份
  }

  // 获取目标月份的最后一天
  let lastDay = new Date(year, targetMonth, 0).getDate();
  let DateDay = Now.getDate(); // 默认使用当前日期

  // 检查目标日期是否超出该月的天数
  if (DateDay > lastDay) {
    DateDay = lastDay; // 如果超出，使用该月最后一天
  }

  // 确保月份和日期都是两位数
  let Month = targetMonth < 10 ? '0' + targetMonth : targetMonth;
  DateDay = DateDay < 10 ? '0' + DateDay : DateDay;

  oldDate = `${year}-${Month}-${DateDay}`;

  let time = []
  time.push(oldDate)
  time.push(this.formatgetDate(Now, 'YYYY-MM-DD'))
  return time
}

function pdroleid(id) {
  var RoleID = sessionStorage.getItem('RoleID')
  if (RoleID.indexOf(id) !== -1) {
    return true
  } else {
    return false
  }
}

/**
 * @param {string} sId
 * @returns {Boolean}
 */
function IsCardID(sId) {
  let _idRe = /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/
  if (!_idRe.test(sId)) {
    return false
  }
  //⾝份证城市
  var aCity = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '⼭西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '⿊龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '⼭东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '⼴东',
    45: '⼴西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '⽢肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '⾹港',
    82: '澳门',
    91: '国外',
  }
  if (!aCity[parseInt(sId.substr(0, 2))]) {
    return false
  }
  // 出⽣⽇期验证
  var sBirthday = (
    sId.substr(6, 4) +
    '-' +
    Number(sId.substr(10, 2)) +
    '-' +
    Number(sId.substr(12, 2))
  ).replace(/-/g, '/'),
    d = new Date(sBirthday)
  if (
    sBirthday != d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()
  ) {
    return false
  }
  // 出⽣⽇期验证
  var sBirthday = (
    sId.substr(6, 4) + '-' + Number(sId.substr(10, 2)) + '-' + Number(sId.substr(12, 2))).replace(/-/g, '/'),
    d = new Date(sBirthday)
  if (
    sBirthday != d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate()
  ) {
    return false
  }
  // ⾝份证号码校验
  if (sId.length == 18) {
    var sum = 0,
      weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
      codes = '10X98765432'
    for (var i = 0; i < sId.length - 1; i++) {
      sum += sId[i] * weights[i]
    }
    var last = codes[sum % 11] //计算出来的最后⼀位⾝份证号码
    if (sId[sId.length - 1] != last) {
      return false
    }
  }
  return true
}

function request_successful(res) {
  new Vue().$notify.closeAll()
  new Vue().$notify({
    title: '成功',
    message: res,
    type: 'success',
  })
}

function request_info(res) {
  new Vue().$notify.closeAll()
  new Vue().$notify({ title: '系统提示', message: res, type: 'warning', duration: 3000, })
}

function request_failure(res) {
  new Vue().$notify.closeAll()
  new Vue().$notify.error({
    title: '错误',
    message: res,
  })
}

function timeFormatSeconds(time) {//时间格式改变
  var d = time ? new Date(time) : new Date();
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var day = d.getDate();
  var hours = d.getHours();
  var min = d.getMinutes();
  var seconds = d.getSeconds();
  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;
  if (hours < 0) hours = '0' + hours;
  if (min < 10) min = '0' + min;
  if (seconds < 10) seconds = '0' + seconds;
  return (year + '-' + month + '-' + day);
}

// CBC加密
function encrypt(word) {
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

// CBC解密
function decrypt(word) {

  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}




  // ecb解密
  function decrypts(word) {
    let key = '890EECEE73FEB38A21AB258E4CF992CC'
    var ecodeKey = CryptoJS.enc.Utf8.parse(key);
    var decrypt = CryptoJS.AES.decrypt(word, ecodeKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    let result = CryptoJS.enc.Utf8.stringify(decrypt).toString();
    return result;
  }

export default {
  encrypt,
  decrypt,
  decrypts,
  selectMenuList,
  selectMenu,
  userID,
  realName,
  SourceNo,
  openInterview,
  DeptName,
  TeachName,
  TrainName,
  haveInterview,
  identity,
  roletype,
  birthday,
  headPhoto,
  ApiUrl,
  regMobile,
  companyLogo,
  companyNM,
  systemNM,
  checkMobile: checkMobile,
  getCurrentTime: getCurrentTime,
  formatDate: formatDate,
  formatgetDate: formatgetDate,
  querycensus: querycensus,
  pdroleid: pdroleid,
  isCardID: IsCardID,
  request_successful: request_successful,
  request_failure: request_failure,
  request_info: request_info,
  setSelectMenu: setSelectMenu,
  SetMenuList: SetMenuList,
  timeFormatSeconds: timeFormatSeconds,
}
